import { render } from "./productsSizeFullCard.vue?vue&type=template&id=402c90c5&scoped=true"
import script from "./productsSizeFullCard.vue?vue&type=script&lang=js"
export * from "./productsSizeFullCard.vue?vue&type=script&lang=js"

import "./productsSizeFullCard.vue?vue&type=style&index=0&id=402c90c5&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-402c90c5"]])

export default __exports__